import { Component } from '@angular/core';

@Component({
    selector: 'app-designate-agent',
    templateUrl: './designate-agent-guide.component.html',
    styleUrl: './designate-agent-guide.component.scss',
    standalone: false
})
export class DesignateAgentGuide {
  
  constructor(){
    
  }
  
}
